import { Helmet } from 'react-helmet-async';
import { SITE, OG_IMAGE, SEO_CONFIG } from './seoConfig';

/**
 * Renders all per-route head tags via react-helmet-async.
 * - `page` keys into the SEO_CONFIG map (home, about, services, etc.).
 * - Optional override props let admin-CMS-managed SEO take precedence at runtime.
 *
 * The same SEO_CONFIG is consumed by the build-time prerender script so
 * non-JS crawlers (LinkedIn, iMessage, Twitter card validator, older bots)
 * see correct metadata in the static HTML for every route.
 */
export default function Seo({ page, title, description, keywords, ogTitle, ogDescription }) {
  const base = SEO_CONFIG[page] || SEO_CONFIG.home;
  const finalTitle = title || base.title;
  const finalDescription = description || base.description;
  const finalKeywords = keywords || base.keywords;
  const finalOgTitle = ogTitle || title || base.title;
  const finalOgDescription = ogDescription || description || base.description;
  const url = `${SITE}${base.path === '/' ? '/' : base.path}`;

  return (
    <Helmet>
      <title>{finalTitle}</title>
      <meta name="description" content={finalDescription} />
      <meta name="keywords" content={finalKeywords} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={finalOgTitle} />
      <meta property="og:site_name" content="Score Integrated Solutions LLC" />
      <meta property="og:description" content={finalOgDescription} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content="Score Integrated Solutions LLC" />
      <meta property="og:locale" content="en_US" />

      {/* Twitter / X */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalOgTitle} />
      <meta name="twitter:description" content={finalOgDescription} />
      <meta name="twitter:image" content={OG_IMAGE} />
    </Helmet>
  );
}
